<template>
  <div ref="viewer" class="app-cesium-viewer"></div>
</template>
<script>
import { CompassView } from '@/libs/cesiumExtents/CesiumPlus.js'
/**
 * 事件列表：loaded
 */
export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    depthTestAgainstTerrain: {
      type: Boolean,
      default: true
    },
    /**
     * 显示指北针
     */
    compass: {
      type: Boolean,
      default: true
    }
  },
  data () {
    // const viewer = undefined
    return {
      // viewer
    }
  },
  methods: {
    // 初始化CesiumViewer
    async initViewer (el) {
      const { depthTestAgainstTerrain } = this
      const defaultOptions = {
        animation: false, // 隐藏动画器件
        timeline: false, // 隐藏时间轴
        geocoder: false, // 搜索按钮
        homeButton: false, // 主页按钮
        sceneModePicker: false,
        baseLayerPicker: false,
        navigationHelpButton: false,
        navigation: false,
        orderIndependentTranslucency: false, // 用来去掉地球表面的大气效果的黑圈问题
        contextOptions: {
          webgl: {
            alpha: true,
            preserveDrawingBuffer: true
          }
        },
        shouldAnimate: true,
        fullscreenButton: false,
        infoBox: false, // 点击实体不弹出信息框
        selectionIndicator: false // 实体不被选中
      }
      const viewer = new Cesium.Viewer(el, Object.assign(defaultOptions, this.options))
      viewer.imageryLayers.addImageryProvider(new Cesium.WebMapTileServiceImageryProvider({
        url: `http://{s}.tianditu.gov.cn/img_c/wmts?service=wmts&request=GetTile&version=1.0.0&LAYER=img&tileMatrixSet=c&TileMatrix={TileMatrix}&TileRow={TileRow}&TileCol={TileCol}&style=default&format=tiles&tk=${process.env.VUE_APP_TDT_TOKEN}`,
        subdomains: ['t0', 't1', 't2', 't3', 't4', 't5', 't6', 't7'],
        tilingScheme: new Cesium.GeographicTilingScheme(),
        tileMatrixLabels: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'],
        maximumLevel: 17,
        layer: 'img',
        style: 'default',
        tileMatrixSetID: 'c'
      }))
      const compassView = this.compass && new CompassView(null, viewer)
      // 开启深度测试
      depthTestAgainstTerrain && (viewer.scene.globe.depthTestAgainstTerrain = true)

      await this.$nextTick()
      // 触发加载完毕时间
      this.$emit('loaded', viewer, this)
      this.viewer = viewer
      this.compassView = compassView
    }
  },
  mounted () {
    this.initViewer(this.$refs.viewer)
  },
  destroyed () {
    this.viewer && this.viewer.destroy()
    this.compassView && this.compassView.destroy()
    this.viewer = this.compassView = undefined
  }
}
</script>

<style lang="scss">
.app-cesium-viewer {
  // Cesium 隐藏图标
  .cesium-credit-logoContainer {
    display: none !important;
  }
}
</style>
<style lang="scss" scoped>
.app-cesium-viewer {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
